import { SiteHeader } from "@/components/site-header";
import { DriversTable } from "./DriversTable";

export default function DriversPage() {
  return (
    <>
      <SiteHeader title="Choferes" />
      <div className="flex-1 p-4 pt-6 w-full flex flex-col">
        <DriversTable />
      </div>
    </>
  );
}
